/**
 * SearchTermsBox Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { Span } from '../../../atoms/text/Label';
import Tag, { TagProps } from '../../../molecules/Tag';
import SearchTerm from './SearchTerm';

interface IOwnProps extends Pick<TagProps, 'colorScheme'> {
  className?: string;
  data: GQL.IHomePageFeaturedTermsList[];
}

// tslint:disable-next-line:no-empty-interface
interface IOwnState {
}

type SearchTermsBoxProps = IOwnProps;

const classes = new BEM('search-terms');

export default class SearchTermsBox extends React.Component<SearchTermsBoxProps, IOwnState> {
  constructor(props: SearchTermsBoxProps) {
    super(props);
  }

  render() {
    const terms = this.props.data[0].items!;
    return (
      <div {...classes('', '', this.props.className) }>
        <header {...classes('header') }>
          <Span variant="description" {...classes('header__title')}>Get<br />Inspired</Span>
        </header>
        <ul {...classes('list') }>
          {terms.map((featuredTerm) => {
            if ((featuredTerm as any).name) {
              const { id, name, taxonomy } = featuredTerm as GQL.ITaxonomyTerm;
              return <SearchTerm
                key={id}
                id={id}
                name={name!}
                taxonomy={taxonomy!}
                colorScheme={this.props.colorScheme}
                {...classes('term')}
              />;
            }
            const { title, url } = featuredTerm as GQL.IHomePageLink;
            return <Tag
              key={title}
              label={title}
              wrappedComponent="li"
              onClick={() => window.location.href = url}
              size="large"
              {...classes('term')}
            />;
          })}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/SearchTermsBox/index.tsx